const CACHE_KEY_PREFIX = 'tour_progress_';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours
const CACHE_VERSION = 2;

const getStorageKey = (userId, teamId) => {
  if (!userId || !teamId) return null;
  return `${CACHE_KEY_PREFIX}${userId}_${teamId}`;
};

export const getTourLocalCache = (userId, teamId) => {
  try {
    const key = getStorageKey(userId, teamId);
    if (!key) return null;

    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const { data, fetchedAt, version } = JSON.parse(cached);
    if (version !== CACHE_VERSION) return null;
    if (Date.now() - fetchedAt > CACHE_DURATION) return null;

    return data;
  } catch {
    return null;
  }
};

export const setTourLocalCache = (userId, teamId, data) => {
  try {
    const key = getStorageKey(userId, teamId);
    if (!key) return;

    localStorage.setItem(
      key,
      JSON.stringify({
        data,
        fetchedAt: Date.now(),
        version: CACHE_VERSION,
      })
    );
  } catch {
    // Ignore storage errors
  }
};

export const mergeTourLocalCache = (userId, teamId, patch) => {
  const existing = getTourLocalCache(userId, teamId) || {};
  setTourLocalCache(userId, teamId, {
    progress: patch?.progress ?? existing.progress ?? {},
    settings: {
      ...(existing.settings ?? {}),
      ...(patch?.settings ?? {}),
    },
  });
};

export const clearTourLocalCache = (userId, teamId) => {
  try {
    const key = getStorageKey(userId, teamId);
    if (!key) return;
    localStorage.removeItem(key);
  } catch {
    // Ignore storage errors
  }
};
